<template>
    <vs-popup class="holamundo" title="Add New Category" :active.sync="isPopupActiveLocal">
                   <div>
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                            <vs-input class="w-full" label="Category Name" name="item-name" v-model="dataName" />
                            <!-- <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span> -->
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <vs-select v-model="dataParentCategory" class="w-full select-large" label="Parent Category">
                                    <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item,index) in parent_cate" class="w-full" />
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-6">
                            <div class="vx-col w-full">
                                <vs-textarea label="Description" v-model="dataDescription" />
                            </div>
                        </div>
                        <div class="vx-row">
                            <div class="vx-col w-full">
                            <vs-button class="mr-3 mb-2" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
                            </div>
                        </div>
                    </div>
                </vs-popup>
</template>

<script>
// import moduleCategoryManagement from '@/store/categories/moduleCategoryManagement.js'

export default {
  props: {
    isPopupActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    },
    catelist: {
      type: Array,
      default: () => {}
    }
  },
  data () {
    return {
      dataId: null,
      dataName: '',
      dataParentCategory: null,
      dataDescription: null,

      ParentCategory_choices: []
      // {text:'Micro Controller Kitwww', value:'Micro Controller Kitwww'},
      // {text:'Micro Controller Kit', value:'Micro Controller Kit'}
      
    }
  },
  watch: {
    isPopupActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { id, name, parentCategory, description} = JSON.parse(JSON.stringify(this.data))
        this.dataId = id
        this.dataName = name
        this.dataParentCategory = parentCategory
        this.dataDescription = description

        this.initValues()
      }
    }

  },
  computed: {
    isPopupActiveLocal: {
      get () {
        return this.isPopupActive
      },
      set (val) {
        if (!val) {
          this.$emit('closePopup')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return this.dataName && this.dataDescription 
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    parent_cate () {
      const pc = []
      // console.log('cates', this.catelist)
      this.catelist.map(cate => {
        pc.push({text: cate.name, value: cate.name})
      })
      return pc
    }
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.dataId = null
      this.dataName = ''
      this.dataParentCategory = null
      this.dataDescription = null

    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
          const obj = {
            id: this.dataId,
            name: this.dataName,
            parentCategory: this.dataParentCategory,
            description: this.dataDescription

          }

          if (this.dataId !== null) {
            this.$store.dispatch('categories/updateCategory', obj).catch(err => { console.error(err) })
          } else {
            delete obj.id
            //obj.popularity = 0
            obj.largeImgUrl = 'image_url'
            this.$store.dispatch('categories/addCategory', obj).catch(err => { console.error(err) })
          }

          this.$emit('closePopup')
          this.initValues()  
        }
      })

    }    

  }
  // created () {
  //   if (!moduleCategoryManagement.isRegistered) {
  //     this.$store.registerModule('categories', moduleCategoryManagement)
  //     moduleCategoryManagement.isRegistered = true
  //   }
  //   this.$store.dispatch('categories/fetchCategories')
  // }
}
</script>